module.exports = __webpack_public_path__ + "static/img/200256.e3228234.png";